import { db } from '@/db/schema';

/**
 * Preferências da aplicação.
 *
 * Chave-valor em vez de colunas fixas: adicionar uma opção nova não deve exigir
 * migration do IndexedDB, e migration é sempre um risco para dados que só existem
 * neste dispositivo.
 */
export const SETTING_KEYS = {
  playbackRate: 'playbackRate',
  loopVideo: 'loopVideo',
  autoCheckUpdates: 'autoCheckUpdates',
  recentSearches: 'recentSearches',
  storagePersistRequested: 'storagePersistRequested',
  lastOfflineCheck: 'lastOfflineCheck',
} as const;

export type SettingKey = (typeof SETTING_KEYS)[keyof typeof SETTING_KEYS];

export async function getSetting<T>(key: SettingKey, fallback: T): Promise<T> {
  const row = await db.settings.get(key);
  return row === undefined ? fallback : (row.value as T);
}

export async function setSetting(key: SettingKey, value: unknown): Promise<void> {
  await db.settings.put({ key, value });
}

export async function getAllSettings(): Promise<Record<string, unknown>> {
  const rows = await db.settings.toArray();
  return Object.fromEntries(rows.map((row) => [row.key, row.value]));
}

export async function removeSetting(key: SettingKey): Promise<void> {
  await db.settings.delete(key);
}
